<template>
  <div>
    <TabsNavigation :tabs="tabs" class="mb-6" />
  </div>
</template>

<script>
import { TabsNavigation } from "@estaly/ui";

export default {
  components: {
    TabsNavigation,
  },

  data() {
    return {
      tabs: [
        { name: "sepa-processing", displayName: "En attente", path: "/admin/leads/processing" },
        { name: "sepa-failed", displayName: "Echoués", path: "/admin/leads/failed" },
      ],
    };
  },
};
</script>
